import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';

export default class ButtonGroup extends Component {
    render() {
        const { children, isLight, isTooltipBtn, testId, className, ...rest } = this.props;
        const classes = cl(
            'btn--group-container',
            { 'btn--group-container--light': isLight },
            { 'btn--group-container--btn-tooltip': isTooltipBtn },
            className
        );
        return (
            <div className={classes} {...rest} data-testid={testId}>
                {children}
            </div>
        );
    }
}

ButtonGroup.defaultProps = {
    testId: 'button-group',
    children: null,
    isLight: false,
    isTooltipBtn: false,
    className: '',
};

ButtonGroup.propTypes = {
    testId: PropTypes.string,
    children: PropTypes.array,
    isLight: PropTypes.bool,
    isTooltipBtn: PropTypes.bool,
    className: PropTypes.string,
};
